export enum ValidType {
    Invalid = 0,
    Valid = 1,
    Recommended = 2,
    Warning = 3
}

(ValidType as any).__typeName = 'ValidType';